export var EventTypes;
(function (EventTypes) {
    EventTypes["Fixture"] = "Fixture";
    EventTypes["Outright"] = "Outright";
    EventTypes["DayOfEventRace"] = "DayOfEventRace";
    EventTypes["AntePostRace"] = "AntePostRace";
})(EventTypes || (EventTypes = {}));
//# sourceMappingURL=EventTypes.js.map